/**
 * Central configuration for tracking events
 * Add any tracking event names to the disabledEvents array to disable them globally
 */
export const TRACKING_CONFIG = {
  /**
   * List of tracking events that should be disabled
   * Common events you might want to disable:
   * - 'remove_from_cart': When items are removed from basket
   * - 'add_to_cart': When items are added to basket
   * - 'purchase': Purchase completion events
   * - 'view_item': Product view events
   * - 'add_to_wishlist': Wishlist add events
   * - 'remove_from_wishlist': Wishlist remove events
   * - 'view_cart': Cart view events
   * - 'begin_checkout': Checkout start events
   * - 'add_shipping_info': Shipping info events
   * - 'add_payment_info': Payment info events
   */
  disabledEvents: [
    'remove_from_cart', // Disabled as requested
    // Add more events here as needed
    // 'add_to_cart',
    // 'purchase',
    // 'view_item',
  ] as const,

  /**
   * Enable debug logging for disabled events (useful for development)
   */
  debugDisabledEvents: process.env.NUXT_PUBLIC_APP_ENV !== 'production',
}

export type TrackingEventName = (typeof TRACKING_CONFIG.disabledEvents)[number]
